/**
 * Chemins du SPA où un visiteur peut naviguer sans session valide.
 * Réutilisé par la bulle support et par l’intercepteur API (401 → pas de redirection violente vers /login).
 */
const EXACT_PUBLIC_PATHS = new Set([
  '/',
  '/pricing',
  '/about',
  '/contact',
  '/accessibility',
  '/le-bref',
  '/blog',
  '/use-cases',
  '/partners',
  '/privacy',
  '/terms',
  '/cookies',
]);

const AUTH_PATHS = new Set([
  '/login',
  '/register',
  '/establishment/register',
  '/forgot-password',
  '/reset-password',
  '/set-password',
  /** Arrivée depuis l'app mobile (échange du code de session). */
  '/handoff',
]);

export function isAuthPath(pathname: string): boolean {
  return AUTH_PATHS.has(pathname);
}

/**
 * Pages de contenu accessibles sans compte, mais qui acceptent aussi une session.
 * Un visiteur déjà connecté doit envoyer son jeton, sinon le serveur redemande une connexion.
 */
export function isOptionalAuthContentPath(pathname: string): boolean {
  if (pathname.startsWith('/podcasts/public') || pathname.startsWith('/podcasts/learner')) return true;
  if (pathname.startsWith('/parcours/public')) return true;
  if (/^\/eduflow\/flows\/[^/]+\/public$/.test(pathname)) return true;
  if (pathname.startsWith('/eduflow/participant/')) return true;
  if (/^\/f\/[^/]+$/.test(pathname)) return true;
  if (pathname.startsWith('/webinars/live/') || pathname.startsWith('/webinars/register/')) return true;
  return false;
}

/** True si la page actuelle est marketing, légale ou auth : une 401 ne doit pas imposer /login (jeton expiré). */
export function isPublicOrAuthPath(pathname: string): boolean {
  if (EXACT_PUBLIC_PATHS.has(pathname)) return true;
  if (pathname.startsWith('/blog/')) return true;
  if (AUTH_PATHS.has(pathname)) return true;
  // Webinar public flow: login is handled inline on the page.
  if (pathname.startsWith('/webinars/live/')) return true;
  if (pathname.startsWith('/webinars/register/')) return true;
  if (pathname.startsWith('/podcasts/public') || pathname.startsWith('/podcasts/learner')) return true;
  if (pathname.startsWith('/parcours/public')) return true;
  if (/^\/eduflow\/flows\/[^/]+\/public$/.test(pathname)) return true;
  if (pathname.startsWith('/eduflow/participant/')) return true;
  if (/^\/f\/[^/]+$/.test(pathname)) return true;
  return false;
}
